import React from 'react';
import { ReactComponent as FigLogOut01Component } from './FigLogOut01.svg';

const FigLogOut01 = (props) => <FigLogOut01Component {...props} />;

export default FigLogOut01;
